/**
 * Cargas que no llegan por ningún banco (la de Tickets, el día 1): cuándo toca avisar y con qué datos proponerla.
 * Puro: recibe los recordatorios y los movimientos.
 */
import type { LoadReminder } from '../adapters/prefs.js';

interface Mov { account: string; date: string; amount: number; concept: string; category: string }

/** Recordatorios que tocan hoy: pasado su día, en un mes no saltado y sin ninguna entrada de dinero en esa cuenta este mes. */
export function dueLoads(reminders: LoadReminder[], movements: Mov[], today: string, dismissed: (account: string, month: string) => boolean) {
  const month = today.slice(0, 7), day = Number(today.slice(8, 10)), m = Number(today.slice(5, 7));
  return reminders.filter(r => day >= r.day && !r.skip.includes(m) && !dismissed(r.account, month)
    && !movements.some(x => x.account === r.account && x.amount > 0 && x.date.startsWith(month)));
}

const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/**
 * El concepto de la carga anterior con el mes de la nueva: «Recarga tickets Octubre 2026» → «… Noviembre 2026». La carga es
 * para el mes que empieza (no se cobra a mes vencido como la nómina), así que va el mes de su fecha. Respeta mayúsculas y
 * cambia el año que vaya detrás del mes.
 */
export function loadConcept(concept: string, date: string) {
  const month = MONTHS[Number(date.slice(5, 7)) - 1]!, year = date.slice(0, 4);
  return concept.replace(/\b(enero|febrero|marzo|abril|mayo|junio|julio|agosto|sept?iembre|octubre|noviembre|diciembre)(\s+(?:de\s+)?)?(\d{4})?\b/gi,
    (_, m: string, sep: string | undefined, y: string | undefined) => {
      const name = m === m.toUpperCase() ? month.toUpperCase() : m[0] === m[0]!.toUpperCase() ? month[0]!.toUpperCase() + month.slice(1) : month;
      return `${name}${y ? `${sep ?? ''}${year}` : sep ?? ''}`;
    });
}

/** La carga anterior de esa cuenta (para proponer su importe, concepto y categoría). */
export function lastLoad(movements: Mov[], account: string) {
  return movements.filter(x => x.account === account && x.amount > 0).sort((a, b) => b.date.localeCompare(a.date))[0] ?? null;
}
